import React            from 'react';
import { TransitionGroup, CSSTransition }   from "react-transition-group";

class Counter extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render() {
        let p = this.props;
        return(
            <CSSTransition
                in          = { p.isFocused }
                classNames  = 'counter-transition'
                timeout     = { 200 }
            >
                <span className="simprakit-textarea-counter">
                    { `${p.charLeft}/${p.maxLength}` }
                </span>
            </CSSTransition> 
        )
    }
}

export default Counter;